import React, {useEffect, useState, useRef} from 'react';
//components
import View from './dashboard-view';
//utils
import {OrganisationService} from '../../../utils/data-transfer';
import {keys, getBooleanSettingValue} from '../../../utils/settings';

const DashboardContainer = () => {
  const showEvents = useRef(getBooleanSettingValue(keys.showEvents));
  const showGroups = useRef(getBooleanSettingValue(keys.showGroups));
  const showMatchplay = useRef(getBooleanSettingValue(keys.showMatchplay));
  const organisationService = useRef(new OrganisationService());
  const [state, setState] = useState({
    isLoading: true,
    myMeetings: [],
    myEvents: [],
    myCompetitions: []
  });

  useEffect(() => {
    const bootstrapComponent = async () => {
      let myMeetings = [];
      let myEvents = [];
      let myCompetitions = []

      if (showGroups.current) {
        myMeetings = (await organisationService.current.getMyUpcomingMeetings()).results;
      }

      if (showEvents.current) {
        myEvents = (await organisationService.current.getMyUpcomingEvents()).results;
      }

      if (showMatchplay.current) {
        myCompetitions = await organisationService.current.getUserCompetitions();
      }

      setState(prevState => ({
        ...prevState,
        isLoading: false,
        myMeetings,
        myEvents,
        myCompetitions,}));
    };

    bootstrapComponent();
  }, []);

  return (
    <View
      {...state}
      showEvents={showEvents}
      showGroups={showGroups}
      showMatchplay={showMatchplay}/>
  );
};

export default DashboardContainer;